import styled from "styled-components";

export const ButtonOpacity = styled.button`
    transition: ease-in 0.2s;
    background: none;
    &:hover{
        opacity: 0.6;
    }
`;